// transfer data between not relate component
// Usage
// emmiter: use bus.$emit to trigger an event to send data
// receiver: use bus.$on to listen event and handle data
// NOTICE: Should call bus.$off in beforeUnmount function to off event
import mitt from 'mitt'
const emitter = mitt()
const bus = {
  $on: emitter.on,
  $emit: emitter.emit,
  $off: emitter.off
}
export default bus
